<div class="modal {{ producttype }}">
	<div class="modal-body">
		<ng-container *ngIf="creative">
			<div class="modal-header">
				<div class="creative-info">
					<div class="creative-name">{{ creative.creativeName }}</div>
					<div class="close-button" (click)="closeModal()">
						<i class="fa fa-times-circle"></i>
					</div>
				</div>
				<div class="clear"></div>
			</div>
			<div *ngIf="!creative.iframeUrl">
				<div class="modal-content">
					<ng-template [ngIf]="creative.hasAdSizes || creative.isNative" [ngIfElse]="noAdSizePreviewBlock">
						<div class="creative-ad-preview">
							<div class="ad_preview_container">
								<div class="ad_preview_gallery my_desktop" *ngIf="creativePreviewUrlObject && creative?.isIAB">
									<div
										class="ad_size_1920x1080 ad_preview"
										*ngIf="(creative?.adSizes)['1920x1080'] && creativePreviewUrlObject['1920x1080']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['1920x1080']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="1920"
												height="1080"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>1920x1080<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_1024x768 ad_preview"
										*ngIf="(creative?.adSizes)['1024x768'] && creativePreviewUrlObject['1024x768']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['1024x768']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="1024"
												height="768"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>1024x768<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_1080x1920 ad_preview"
										*ngIf="(creative?.adSizes)['1080x1920'] && creativePreviewUrlObject['1080x1920']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['1080x1920']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="1080"
												height="1920"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>1080x1920<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_1080x1620 ad_preview"
										*ngIf="(creative?.adSizes)['1080x1620'] && creativePreviewUrlObject['1080x1620']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['1080x1620']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="1080"
												height="1620"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>1080x1620<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_400x1400 ad_preview"
										*ngIf="(creative?.adSizes)['400x1400'] && creativePreviewUrlObject['400x1400']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['400x1400']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="400"
												height="1400"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>400x1400<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_400x840 ad_preview"
										*ngIf="(creative?.adSizes)['400x840'] && creativePreviewUrlObject['400x840']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['400x840']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="400"
												height="840"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>400x840<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_1400x400 ad_preview"
										*ngIf="(creative?.adSizes)['1400x400'] && creativePreviewUrlObject['1400x400']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['1400x400']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="1400"
												height="400"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>1400x400<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_840x400 ad_preview"
										*ngIf="(creative?.adSizes)['840x400'] && creativePreviewUrlObject['840x400']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['840x400']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="840"
												height="400"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>840x400<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_300x600 ad_preview"
										*ngIf="(creative?.adSizes)['300x600'] && creativePreviewUrlObject['300x600']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['300x600']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="300"
												height="600"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>300x600<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_160x600 ad_preview"
										*ngIf="(creative?.adSizes)['160x600'] && creativePreviewUrlObject['160x600']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['160x600']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="160"
												height="600"
												allowfullscreen=""
											></iframe>
											<!--<div class="ad_preview_iframe">-->
											<!--<img [src]="creative.adSizes['160x600'].creativeThumbnail"/>-->
											<!--</div>-->
											<span class="ad_size_title"
												>160x600<span class="scale_text">
													scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
												></span
											>
										</div>
										<span class="ad_size_title"
											>160x600<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_300x250 ad_preview"
										*ngIf="(creative?.adSizes)['300x250'] && creativePreviewUrlObject['300x250']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['300x250']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="300"
												height="250"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>300x250<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_336x280 ad_preview"
										*ngIf="(creative?.adSizes)['336x280'] && creativePreviewUrlObject['336x280']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['336x280']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="336"
												height="280"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>336x280<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_300x50 ad_preview"
										*ngIf="(creative?.adSizes)['300x50'] && creativePreviewUrlObject['300x50']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['300x50']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="300"
												height="50"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>300x50<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_320x50 ad_preview"
										*ngIf="(creative?.adSizes)['320x50'] && creativePreviewUrlObject['320x50']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['320x50']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="320"
												height="50"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>320x50<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_728x90 ad_preview"
										*ngIf="(creative?.adSizes)['728x90'] && creativePreviewUrlObject['728x90']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['728x90']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="728"
												height="90"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>728x90<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_468x60 ad_preview"
										*ngIf="(creative?.adSizes)['468x60'] && creativePreviewUrlObject['468x60']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['468x60']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="468"
												height="60"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>468x60<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<!-- 970x250 -->
									<div
										class="ad_size_970x250 ad_preview"
										*ngIf="(creative?.adSizes)['970x250'] && creativePreviewUrlObject['970x250']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['970x250']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="970"
												height="250"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>970x250<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<div
										class="ad_size_3840x2160 ad_preview"
										*ngIf="(creative?.adSizes)['3840x2160'] && creativePreviewUrlObject['3840x2160']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['3840x2160']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="3840"
												height="2160"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>3840x2160<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<!-- 1x1 -->
									<div
										class="ad_size_1x1 ad_preview"
										*ngIf="(creative?.adSizes)['1x1'] && creativePreviewUrlObject['1x1']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['1x1']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="350"
												height="350"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>1x1<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<!-- 1920x175 -->
									<div
										class="ad_size_1920x175 ad_preview"
										*ngIf="(creative?.adSizes)['1920x175'] && creativePreviewUrlObject['1920x175']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['1920x175']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="1920"
												height="175"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>1920x175<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<!-- 728x150 -->
									<div
										class="ad_size_728x150 ad_preview"
										*ngIf="(creative?.adSizes)['728x150'] && creativePreviewUrlObject['728x150']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['728x150']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="728"
												height="150"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>728x150<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
									<!-- 320x150 -->
									<div
										class="ad_size_320x150 ad_preview"
										*ngIf="(creative?.adSizes)['320x150'] && creativePreviewUrlObject['320x150']"
									>
										<div class="ad_scale_container" style="-webkit-transform: none; transform: none">
											<iframe
												class="ad_preview_iframe"
												[src]="creativePreviewUrlObject['320x150']"
												scrolling="no"
												marginwidth="0"
												marginheight="0"
												frameborder="0"
												width="320"
												height="150"
												allowfullscreen=""
											></iframe>
										</div>
										<span class="ad_size_title"
											>320x150<span class="scale_text">
												scaled to <span class="ad_size_scale_percent">100%</span> of actual size</span
											></span
										>
									</div>
								</div>
								<div class="nativeAdPreview" *ngIf="creative?.isNative">
									<p class="native-title">Native Ad Preview</p>
									<div class="ad_scale_container">
										<div class="desktop-preview-div">
											<div class="background-desktop-image">
												<img src="../../../../../assets/creative-assets/desktop-preview.png" class="desktop-preview" />
											</div>
											<img [src]="creative?.native?.url" class="desktop-native-ad" />
											<div class="desktop-native-ad-desc">
												<h2 [title]="creative?.native?.long_title">{{ creative?.native?.long_title }}</h2>
												<p [title]="creative?.native?.long_description">{{ creative?.native?.long_description }}</p>
											</div>
										</div>
										<div class="low-res-devices">
											<img src="../../../../../assets/creative-assets/mobile-preview.png" class="mobile-preview" />
											<div class="mobile-native-ad-desc">
												<h2 [title]="creative?.native?.short_title">{{ creative?.native?.short_title }}</h2>
												<p [title]="creative?.native?.short_description">{{ creative?.native?.short_description }}</p>
											</div>
											<img [src]="creative?.native?.url" class="mobile-native-ad" />
											<img src="../../../../../assets/creative-assets/tablet-preview.png" class="tablet-preview" />
											<div class="tablet-native-ad-desc">
												<h2 [title]="creative?.native?.long_title">{{ creative?.native?.long_title }}</h2>
												<p [title]="creative?.native?.long_description">{{ creative?.native?.long_description }}</p>
											</div>
											<img [src]="creative?.native?.url" class="tablet-native-ad" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-template>
					<ng-template #noAdSizePreviewBlock>
						<div style="font-size: 1.6em; padding: 30px 20px">No different adsizes available for preview.</div>
					</ng-template>
					<div class="clear"></div>
				</div>
			</div>
			<div *ngIf="creative.iframeUrl !== null && creative.iframeUrl.length > 0">
				<div class="modal-content social">
					<div
						class="social-iframe-container"
						*ngIf="creative.isIframeExpired == 0 || !creative.isIframeExpired"
						[innerHtml]="iframeUrl"
					></div>
					<div class="social-iframe-container" *ngIf="creative.isIframeExpired === 1 || creative.isIframeExpired">
						<div *ngIf="creative.hasSnapshotImage" class="social-iframe-container">
							<img [src]="creative.snapshotImage" [alt]="creative.creativeName" />
						</div>
						<div *ngIf="!creative.hasSnapshotImage" class="social-iframe-container">
							<img src="/assets/images/iframe_ad_not_available.png" [alt]="creative.creativeName" />
						</div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
